import {
    styledKickerClassName,
    styledKickerTextClassName,
} from 'component-library/cards/Kicker/Kicker.styled'
import { styledMediaClassName } from 'component-library/cards/CardMedia/StyledMedia.styled'
import { playOverlayClassName } from 'component-library/content/Video/components/PlayOverlay/PlayOverlay'

// Because the video sits inside a Link we need to check to see if the video element,
// interface or play button is clicked in order to ignore the link and hide the kicker
export function isVideoClick(className: string) {
    const videoTriggerClasses = [
        'video',
        'vjs',
        styledMediaClassName,
        styledKickerClassName,
        styledKickerTextClassName,
        playOverlayClassName,
    ]
    return new RegExp(videoTriggerClasses.join('|')).test(className)
}
